import LoginView from "./LoginView";
import HomeView from "./HomeView";
import MyProfileView from "./MyProfileView";
import EditRepeatsView from "./EditRepeatsView";
import SponsorsView from "./SponsorsView";
import InviteSponsorView from "./InviteSponsorView";
import InvitePreviousSponsorsView from "./InvitePreviousSponsorsView";
import AboutKKView from "./AboutKKView";
import AddSponsorView from "./AddSponsorView";
import ChooseEventView from "./ChooseEventView";
import ChooseOrganizationView from "./ChooseOrganizationView";
import StartView from "./StartView";
import StatisticsView from "./StatisticsView";
import UserStatisticsView from "./UserStatisticsView";
import EventStatisticsView from "./EventStatisticsView";
// import OrganizationStatisticsView from "./OrganizationStatisticsView";
import AllStatisticsView from "./AllStatisticsView";
import TopEventParticipants from "./TopEventParticipantsView";
import PermissionView from "./PermissionView";
import InstructionsView from "./InstructionsView";
import MobileAppInstructionsView from "./MobileAppInstructionsView";
import PrivacySettingsView from "./PrivacySettingsView";
export var routes = [
    { name: "LoginView", path: "/login", component: LoginView },
    { name: "Start", path: "/start", component: StartView },
    { name: "HomeView", path: "/", component: HomeView },
    { name: "MyProfileView", path: "/myprofile", component: MyProfileView },
    { name: "PrivacySettings", path: "/privacy-settings", component: PrivacySettingsView },
    { name: "SponsorsView", path: "/sponsors", component: SponsorsView },
    { name: "InviteSponsorView", path: "/invite-sponsor", component: InviteSponsorView },
    { name: "InvitePreviousSponsors", path: "/invite-previous-sponsors", component: InvitePreviousSponsorsView },
    { name: "AboutKK", path: "/about", component: AboutKKView },
    { name: "AddSponsorView", path: "/add-sponsor", component: AddSponsorView },
    { name: "ChooseEventView", path: "/choose-event", component: ChooseEventView },
    { name: "ChooseOrganizationView", path: "/choose-organization", component: ChooseOrganizationView },
    {
        name: "StatisticsView",
        path: "/statistics",
        component: StatisticsView,
        children: [
            { path: 'user', component: UserStatisticsView },
            { path: 'event', component: EventStatisticsView },
            /* { path: 'organization', component: OrganizationStatisticsView }, */
            { path: 'participants', component: TopEventParticipants },
            { path: 'all', component: AllStatisticsView },
        ],
    },
    { name: "EditLapsView", path: "/edit-laps", component: EditRepeatsView },
    { name: "PermissionView", path: "/permission", component: PermissionView },
    { name: "InstructionsView", path: "/instructions", component: InstructionsView },
    { name: "MobileAppInstructionsView", path: "/mobile-app-instructions", component: MobileAppInstructionsView },
    // Redirect unknown routes to home view
    { path: "*", redirect: "/" },
];



//////////////////
// WEBPACK FOOTER
// ./app/ts/views/index.ts
// module id = 79
// module chunks = 0